import React from 'react';

import {DomainIncidents, useLastDomainIncidents} from 'features/domain';
import LoaderCentered from 'shared/ui/LoaderCentered/LoaderCentered';
import PlugNoIncidents from 'shared/ui/Plugs/PlugNoIncidents/PlugNoIncidents';

import {LAST_INCIDENTS_LIMIT} from '../../../lib/incidentTabs';

const DomainIncidentsTab: React.FC = () => {
    const {pagination, isLoading, isFetching} = useLastDomainIncidents(LAST_INCIDENTS_LIMIT);

    return (
        <>
            <LoaderCentered active={isFetching}/>
            <DomainIncidents
                pagination={pagination}
                isLoading={isLoading}
                hidePagination
            />
            {!isLoading && pagination?.items.length === 0 && <PlugNoIncidents size="sm"/>}
        </>
    );
};

export default DomainIncidentsTab;
